import styled from "styled-components";
import { device } from "../../styles/devices";

export const ContactContainer = styled.div`
    max-width: 1200px;
    margin: 0 auto;
    width: 100%;
    padding: 0 20px;
`;
export const ContactContent = styled.section`
    padding: 5rem 0;
    margin: 3rem 0;

    @media ${device.tablet}{
        margin: 0;
        padding: 3rem 0 7rem;
    }

    h2 {
        font-size: 2.5rem;
        line-height: 3rem;
        color: var(--color-title);
        margin-bottom: 0.5rem;
        text-align: center;

        @media ${device.tabletLarge}{
            font-size: 2.5rem;
            line-height: 3rem;
        }

        @media ${device.tablet}{
            font-size: 2rem;
            line-height: 2.5rem;
        }

        @media ${device.mobile}{
            text-align: initial;
        }
    }

   & > div > p {
        font-size: 1rem;
        font-weight: var(--font-normal);
        text-align: center;
        color: var(--color-text);

        @media ${device.mobile}{
            text-align: initial;
        }
    }

`;

export const ContactGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1.7fr;
    gap: 5rem;

    margin-top: 2rem;

    @media ${device.tabletLarge}{
        grid-template-columns: 1fr 2fr;
        gap: 3rem;
    }

    @media ${device.tablet}{
        grid-template-columns: 1fr;
        gap: 4rem;
    }
`